var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "#FFF",
    id: "Capa_1",
    viewBox: "0 0 8.467 8.467",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.816.792a.265.265 0 0 0-.038.004h-4.72a.265.265 0 0 0-.265.266v5.555c0 .581.477 1.057 1.059 1.057h4.763a.265.265 0 0 0 .095-.01c.537-.05.964-.498.964-1.047V4.5a.265.265 0 0 0-.266-.264H6.086V1.062a.265.265 0 0 0-.27-.27Zm-4.494.534h4.235V4.45a.265.265 0 0 0 0 .092v2.074c0 .193.056.373.148.529H1.852a.522.522 0 0 1-.53-.53zm.768 1.059a.265.265 0 0 0 .027.529h2.644a.265.265 0 1 0 0-.53H2.117a.265.265 0 0 0-.027 0zm0 1.058a.265.265 0 0 0 .027.53h2.644a.265.265 0 1 0 0-.53H2.117a.265.265 0 0 0-.027 0zM2.117 4.5a.265.265 0 1 0 0 .529h2.644a.265.265 0 1 0 0-.53zm3.969.265h1.059v1.852c0 .296-.23.528-.527.529a.265.265 0 0 0-.003 0 .522.522 0 0 1-.53-.53zm-3.995.793a.265.265 0 0 0-.001 0 .265.265 0 0 0 .027.53h2.644a.265.265 0 1 0 0-.53H2.117a.265.265 0 0 0-.026 0z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      shapePadding: 0,
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.5e0472b36c5235b57a8346deb2321e8c.svg";
export { ForwardRef as ReactComponent };